import { Component } from '@angular/core';
import { GlobalAdjustments } from '../models/global-adjustments.model';
import { ReportSettings } from '../models/report-settings.model';
import { GlobalSettings } from '../models/global-settings.model';
import { GlobalSettingsService } from '../services/global-settings.service';
import { PermissionService } from '../../auth/services/permission.service';
import { UserAddons } from '../models/user-addons.model';

const maxDaysIntroduced = 600;

@Component({
    templateUrl: './settings-report-options.component.html',
    styleUrls: [ './settings-report-options.component.scss' ]
})

export class ReportSettingsComponent {
    settings: GlobalSettings;
    reportSettings: ReportSettings;
    userAddons: UserAddons;

    altDerivativeModes = [
        {value: 0, name: 'Base'},
        {value: 1, name: 'Most Expensive'}
    ];

    constructor(private settingsService: GlobalSettingsService, private permissionService: PermissionService) {
        this.setDefaultUserAddons();
        this.reportSettings = new ReportSettings();
        this.settingsService.onGlobalSettingsUpdated.subscribe(
            (response) => {
                this.settings = response;
                this.reportSettings = this.settings.reportSettings;
            },
            (error) => {
                console.log(error);
            }
        );
        this.settingsService.onUserAddonsUpdated.subscribe(
            (response) => {
                this.userAddons = response;
            },
            (error) => console.log(error)
        );
        this.settingsService.getGlobalAdjustments();
        this.settingsService.getUserAddons();
    }

    updateGlobalAdjustments(areaChanged: string) {
        this.settingsService.recordChangedField(areaChanged);
        this.settingsService.updateGlobalAdjustments(this.settings);
    }

    updateAltDerivatives() {
        let altModeName = this.altDerivativeModes.find(v => v.value==this.settings.reportSettings.altDerivativeMode).name;
        this.settingsService.recordAltDerivativeChange(altModeName);
        this.settingsService.updateGlobalAdjustments(this.settings);
    }

    private setDefaultUserAddons() {
        const userAddons = new UserAddons();
        userAddons.hasVrm = false;
        userAddons.hasVin = false;
        userAddons.hasCar = false;
        userAddons.hasLcv = false;
        userAddons.hasHgv = false;
        userAddons.hasBike = false;

        this.userAddons = userAddons;
    }

    invalidDaysIntroduced(daysIntroduced){
        return daysIntroduced > maxDaysIntroduced;
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/components/settings-report-options.component.ts